import axiosIns from "@/api/axios";

export const GET_LIST = () => {
  return axiosIns.get("/job-readiness-all");
};

export const DETAIL = (id) => {
  return axiosIns.get(`/job-readiness?id=${id}`);
};

export const GET_LIST_BY_USER = (id) => {
  return axiosIns.get(`/job-readiness/user/${id}`);
};
